import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ref } from '@dbk-legacy/muster/utils';
import filter from 'lodash/fp/filter';
import update from 'lodash/fp/update';
import findIndex from 'lodash/findIndex';
import Text from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import BackLink from '../../../../../../src/components/common/back-link';
import ReportPortfolioSelector from './report-portfolio-selector';
import { ALL_REPORT_PORTFOLIO, REPORT_PORTFOLIO_ID, ReportTypes, SELECTED_RANGE, CUSTOM_REPORT_SELECTED_RANGE } from '../../../screens/reports/constants';

class ReportPortfolio extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataSet: 0,
      reportPortfolioData: []
    }
    this.getSelectedPortfolioIndex = this.getSelectedPortfolioIndex.bind(this);
    this.handlePortfolioPress = this.handlePortfolioPress.bind(this);
  }

  componentWillMount() {
    const {
        reports: {
          user: {
            setSelectedPortfolioId
          }
        }
    } = this.props;
    const reportPortfolioElements = [];
    if (this.props.reports.user.reportsPortfoliosData.length > 0) {
      this.props.reports.user.reportsPortfoliosData.map((portfolio) => {
        reportPortfolioElements.push(portfolio);
        return reportPortfolioElements;
      });
      setSelectedPortfolioId(this.props.reports.user.reportsPortfoliosData[0]);
      if (this.props.reports.user.reportsPortfoliosData.length > 1) {
        reportPortfolioElements.unshift(ALL_REPORT_PORTFOLIO);
        setSelectedPortfolioId(ALL_REPORT_PORTFOLIO);
      }
      this.setState({ reportPortfolioData: reportPortfolioElements });
    } else {
      this.setState({ reportPortfolioData: 0 });
    }
  }

  /*
  function : handlePortfolioPress will select portfoliolist item from modal
  Output   : Report data will get populated with selected portfolio id
   */

  async handlePortfolioPress(portfolio) {
    const {
      getDocuments,
      reports: { selectedReportType, user, selectedReportDetailsDateRange, startDate, endDate, custom, trans:{isTransactionSelected} }
    } = this.props;
    user.setSelectedPortfolioId(portfolio);
    this.props.setTransactionHistoryData(undefined);
    if (selectedReportType === ReportTypes.STATEMENTS) {
      // if (selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
      // const date = { fromDate: startDate, toDate: endDate };
      if (startDate && endDate) {
        this.props.fetchDocumentsForCategories(startDate, endDate);
      }

      // } else {
      getDocuments();
      // }
    }
    if(isTransactionSelected){
      if (custom.startDate && custom.endDate ) {
        this.props.getCustomDateRangeData(custom.startDate, custom.endDate);
      }
      else {
       this.props.getTransactionDetails();
      }
    }
  }


  /*
  function : getSelectedPortfolioIndex will return index of selected portfolio item
  Output   : Index number will get updated with selected portfolio on  portfolio header
   */

  getSelectedPortfolioIndex(portfolios) {
    const foundIndex = findIndex(portfolios, (p) =>
      p.id === this.props.reports.user.selectedPortfolioId.id);
    return foundIndex + 1
  }

  render() {
    const {
      rsa,
      vascoauthentication,
      i18n: { messages },
    } = this.props;
    const parsedPortfolioList = this.state.reportPortfolioData;
    let selectedPortfolioIdReports = null;
    if(parsedPortfolioList.length === 1){
       selectedPortfolioIdReports = this.props.reports.user.reportsPortfoliosData[0];
    }
    else{
       selectedPortfolioIdReports = this.props.reports.user.selectedPortfolioId;
    }
    const selectedPortfolio = this.getSelectedPortfolioIndex(parsedPortfolioList);
    const portfolioIndex = `${messages['app.common.pageTitle.portfolio']} ${ selectedPortfolio === 0 ? 1 : selectedPortfolio } ${messages['app.profile.consolidated.of']} ${parsedPortfolioList.length}`

    return (
      <div className="app-header edel-header">
        {(
          <div className="portfolio-bar">
            <div className="portfolio-row">
              <div className="small-2 column text-left">
                <BackLink messages={messages} />
              </div>
              <div className="small-10 column text-right">
                {parsedPortfolioList.length > 0 && <div className="portfolio-box">
                  <Text className="portfolio-index">
                    {portfolioIndex}
                  </Text>
                  <div className="portfolio-list-selector">
                    <ReportPortfolioSelector
                      portfolios={parsedPortfolioList}
                      selectedPortfolio={selectedPortfolioIdReports}
                      onPortfolioSelect={this.handlePortfolioPress}
                      onRsaAuthorised={rsa.rsaAuthorised}
                      onVascoAuthorised={vascoauthentication.vascoAuthorised}
                      messages={messages}
                    />
                  </div>
                </div>}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

ReportPortfolio.propTypes = {
  ui: PropTypes.shape({
    customtitle: PropTypes.string,
  }),
  app: PropTypes.shape({
    user: PropTypes.shape({
    }),
  }),
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  reports: PropTypes.object,
};

ReportPortfolio.defaultProps = {
  i18n: {},
  reports: {},
  app: {},
  ui: {}
};

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.push' },
      replacePage: { $call: 'ui.history.replace' },
      clearData: { $call: 'portfolio.clearData' },
      app: {
        user: {
          portfolios: {
            $type: 'list',
            $range: {
              offset: 0,
              length: ref('app.user.portfolios.length'),
            },
            $node: {
              id: true,
              title: true,
              referenceCurrency: true,
              relId: true,
              branchCode: true,
              isPaymentAvailable: true,
              isEDeliveryAvailable: true,
              isDownloadAvailable: true,
            }
          },
        },
      },
      auth: {
        entitlement: true,
        passwordExpired: true,
      },
      rsa: {
        rsaAuthorised: true,
        onChangePage: { $call: 'changePage' },
      },
      vascoauthentication: {
        vascoAuthorised: true,
      },
      i18n: {
        messages: true,
      },
      ui: {
        setDebug: { $set: 'debug' },
        title: true,
        customtitle: true,
        history: {
          currentLocation: {
            pathname: true,
          },
        },
      },
      notifications: {
        userNotifications: true,
      },
      search: {
        clearSearchFilters: { $call: 'clearFilters' },
        setPortfolioIds: { $set: 'portfolioIds' },
      },
      callback: {
        screen: true,
        setScreen: { $call: 'setScreen' },
        setPage: { $set: 'pagename' },
      },
      reports: {
        user: {
          selectedPortfolioId: true,
          setSelectedPortfolioId: {
            $set: 'selectedPortfolioId',
          },
          setSelectedPortfolioData: {
            $set: 'selectedPortfolioData',
          },
          selectedPortfolioData: true,
          portfoliosData: true,
          setPortfoliosData: {
            $set: 'portfoliosData',
          },
          reportsPortfoliosData: true,
        },
        selectedReportType: true,
        selectedReportDetailsDateRange: true,
        startDate: true,
        endDate: true,
        custom: {
          startDate: true,
          endDate: true,
        },
        trans: {
          customSelectedTab: true,
          isTransactionSelected: true
        }
      },
      setTransactionHistoryData: {
        $call: 'reports.trans.setTransactionDetails'
      },
      getTransactionDetails: {
        $call: 'reports.trans.getTransactionDetails'
      },
      fetchDocumentsForCategories: {
        $call: 'reports.fetchDocumentsForCategories'
      },
      getDocuments: {
        $call: 'reports.getDocuments',
      },
      refreshReportsView: {
        $call: 'reports.refreshReportsView'
      },
      getCustomDateRangeData: {
        $call: 'reports.trans.getSelectedRangeDataForCustomReport'
      },
    },
    $renderError: () => null,
  },
  update(['app', 'user', 'portfolios'], filter((p) => p && p.id != null))
)(ReportPortfolio);
